exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Form__form__1NQ23{padding:.5em;display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/form/src/components/controls/form/Form.scss"],"names":[],"mappings":"AAEA,mBACI,aAAc,AAEd,oBAAa,AAAb,aAAa,AACb,qBAAiB,AAAjB,gBAAiB,CACpB","file":"Form.scss","sourcesContent":["@import \"../base\";\n\n.form {\n    padding: 0.5em;\n\n    display: flex;\n    flex-flow: column;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"form": "Form__form__1NQ23"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/form/Form.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/form/Form.scss
// module chunks = 0